<template>
    <v-layout>
        <v-flex xs=12>
        <div v-for="item in items" v-bind:key="item.name">
            <v-card style="margin-bottom:10px" :to="{name: item.name}">
                <v-card-title primary-title>
                    <v-icon style="margin-right:10px">{{item.icon}}</v-icon>
                    <div>
                        <h3 class="headline mb-0">{{item.text}}</h3>
                    </div>
                </v-card-title>
            </v-card>
        </div>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        data: () => ({
            x: false,
            items: [
                { icon: 'fastfood', text: 'Categories', name: "categories" },
                { icon: 'settings', text: 'Restaurants', name: "restaurants" }
            ]
        })
    };
</script>